var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"privacy-main"},[_c('authHeader'),_c('h3',{staticClass:"text-center mt-5"},[_vm._v("Privacy Policy")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }